<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <carriage-list-filter
      @edit="editComponentFilters($event, 'filter__carriage__in')"
      @clean="cleanComponentFilters(['filter__carriage__in'])"
    />
    <transport-by-list-filter
      @edit="editComponentFilters($event, 'filter__transport_by__in')"
      @clean="cleanComponentFilters(['filter__transport_by__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as DELIVERY_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'deliveryCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...DELIVERY_TYPES.GENERIC.carriage.delivery.LIST.ACTIONS
    })
  }
}
</script>
